"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
require("core-js/modules/es6.function.name");
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "dashboard-container"
  }, [_c("div", {
    staticClass: "dashboard-header"
  }, [_c("div", {
    staticClass: "header-left"
  }, [_c("img", {
    staticClass: "logo",
    attrs: {
      src: require("@/assets/logo.png"),
      alt: "logo"
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "welcome"
  }, [_c("span", {
    staticClass: "greeting"
  }, [_vm._v("Hi " + _vm._s(_vm.name) + "，")]), _vm._v(" "), _c("span", {
    staticClass: "message"
  }, [_vm._v("欢迎回来")])])]), _vm._v(" "), _c("div", [_c("el-date-picker", {
    attrs: {
      type: "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: _vm.value1,
      callback: function callback($$v) {
        _vm.value1 = $$v;
      },
      expression: "value1"
    }
  }), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.getIndexData
    }
  }, [_vm._v("查看")]), _vm._v(" "), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.resetData
    }
  }, [_vm._v("重置")])], 1)]), _vm._v(" "), _vm.data.length == 0 ? _c("el-skeleton") : _vm._e(), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isAdmin || _vm.name == "wangdi",
      expression: "isAdmin || name == 'wangdi'"
    }],
    staticClass: "admin-section"
  }, [_vm._m(0), _vm._v(" "), _c("el-row", [_c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("支付订单金额")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.pay_all_money, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/1.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("订单服务费收入")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.rate_money, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/1.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("订单服务费收入(非)")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.no_saas_rate_money, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/1.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#faefd9 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#fe9604"
    }
  }, [_vm._v("划扣流水(总)")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.pay_sum, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/2.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#faefd9 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#fe9604"
    }
  }, [_vm._v("划扣流水(京东)")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.jd_pay_sum, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/2.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#faefd9 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#fe9604"
    }
  }, [_vm._v("划扣抽成（0.007）")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum((_vm.data.hkh_money + _vm.data.pay_sum) / 1000 * 7, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/2.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#d9fae4 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#02be2a"
    }
  }, [_vm._v("返点总金额")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.f_money, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/8.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#d9fae4 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info",
    on: {
      click: function click($event) {
        return _vm.getMoneyReal(1);
      }
    }
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#02be2a"
    }
  }, [_vm._v("划扣回款总金额")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(this.money_hkhk_tj, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/8.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#d9fae4 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info",
    on: {
      click: function click($event) {
        return _vm.getMoneyReal(4);
      }
    }
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#02be2a"
    }
  }, [_vm._v("提现总金额")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(this.money_yetx_tj, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/8.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("订单服务费抽成（0.01）")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.f_all_rate_money / 100, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/1.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("合同费收入")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.contract_money, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/1.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#faefd9 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#fe9604"
    }
  }, [_vm._v("逾期划扣回款金额")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.hkhy_money, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/2.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#faefd9 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#fe9604"
    }
  }, [_vm._v("逾期划扣回款期数")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(_vm.data.hkhy_num) + "期")])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/2.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#d9fae4 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info",
    on: {
      click: function click($event) {
        return _vm.getMoneyReal(2);
      }
    }
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#02be2a"
    }
  }, [_vm._v("商户承担合同费用")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(this.money_htshc_tj, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/8.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#d9fae4 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info",
    on: {
      click: function click($event) {
        return _vm.getMoneyReal(3);
      }
    }
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#02be2a"
    }
  }, [_vm._v("预存支付宝总金额")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(this.money_yczf_tj, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/8.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("签约订单数")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(_vm.data.ensign_sum) + "笔")])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/1.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("划扣手续费收入")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.hkh_money, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/1.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#faefd9 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#fe9604"
    }
  }, [_vm._v("按时划扣回款金额")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.hkhd_money, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/2.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#faefd9 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#fe9604"
    }
  }, [_vm._v("按时划扣回款期数")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(_vm.data.hkhd_num) + "期")])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/2.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#d9fae4 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info",
    on: {
      click: function click($event) {
        return _vm.getMoneyReal(5);
      }
    }
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#02be2a"
    }
  }, [_vm._v("其他充值")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(this.money_qita_tj, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/8.png"),
      alt: ""
    }
  })])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 4
    }
  }, [_c("div", {
    staticClass: "grid-item",
    staticStyle: {
      border: "#d9fae4 solid 2px"
    }
  }, [_c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label",
    staticStyle: {
      color: "#02be2a"
    }
  }, [_vm._v("e签宝预存金额")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.merchant_balance, 2)))])]), _vm._v(" "), _c("div", {
    staticClass: "desktop-view"
  }, [_c("img", {
    staticClass: "grid-icon",
    attrs: {
      src: require("../../assets/8.png"),
      alt: ""
    }
  })])])])], 1)], 1), _vm._v(" "), _c("div", {
    staticClass: "shop-section"
  }, [_vm._m(1), _vm._v(" "), _c("div", {
    staticClass: "shop-grid"
  }, [_c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(2), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("订单总值")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.all_money, 2)) + "元")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(3), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("已支付订单")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(_vm.data.pay_num) + "笔")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(4), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("收到蚂蚁链划扣流水")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.pay_sum - _vm.data.jd_pay_sum, 2)) + "元")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(5), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("收到京东划扣流水")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.jd_pay_sum, 2)) + "元")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(6), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("蚂蚁链可提现金额(低于50元不可提现)")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.alipay_money, 2)) + "元")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(7), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("蚂蚁链未入账金额(同步间隔30min)")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.money_wrz_tj, 2)) + "元")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(8), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("京东可提现金额(低于50元不可提现)")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.alipay_jd_money, 2)) + "元")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(9), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("京东未入账金额(同步间隔35min)")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.money_wrz_jd_tj, 2)) + "元")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(10), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("代收账户可提现金额(低于50元不可提现)")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.alipay_ds_money, 2)) + "元")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(11), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("代收账户未入账金额(同步间隔40min)")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(_vm.data.money_wrz_ds, 2)) + "元")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(12), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("逾期订单数")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.overdue_num) + "笔")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(13), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("逾期订单总金额")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(this.overdue_all_money, 2)) + "元")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(14), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("逾期订单待归还金额")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.formatNum(this.overdue_money, 2)) + "元")])])])]), _vm._v(" "), _c("div", {
    staticClass: "grid-item"
  }, [_c("div", {
    staticClass: "grid-content"
  }, [_vm._m(15), _vm._v(" "), _c("div", {
    staticClass: "grid-info"
  }, [_c("div", {
    staticClass: "grid-label"
  }, [_vm._v("申请解约待处理订单数")]), _vm._v(" "), _c("div", {
    staticClass: "grid-value"
  }, [_vm._v(_vm._s(this.us_num) + "笔")])])])])]), _vm._v(" "), _c("el-row", {
    attrs: {
      gutter: 20
    }
  }, [_c("el-col", {
    attrs: {
      span: 18
    }
  }, [_c("div", {
    staticClass: "carditem"
  }, [_c("div", {
    staticClass: "cardtitle"
  }, [_c("span", {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("订单数据")])]), _vm._v(" "), _c("div", {
    staticClass: "cardcontent"
  }, [_c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "flex-direction": "column",
      "align-items": "center",
      "justify-content": "center",
      "padding-top": "30px"
    }
  }, [_c("div", [_c("img", {
    attrs: {
      src: require("../../assets/2.png"),
      alt: ""
    }
  })]), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("正常订单: "), _c("span", {
    staticStyle: {
      "font-weight": "600",
      "font-size": "26px"
    }
  }, [_vm._v(_vm._s(_vm.data.zc_num))]), _vm._v("笔")])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 18
    }
  }, [_c("el-row", {
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "shouitem"
  }, [_c("div", {
    staticClass: "shoutitle"
  }, [_c("i", {
    staticClass: "el-icon-s-management shouicon"
  }), _vm._v("\n                        正常订单\n                      ")]), _vm._v(" "), _c("div", {
    staticClass: "shouvalue"
  }, [_vm._v(" " + _vm._s(_vm.data.zc_num))])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "shouitem"
  }, [_c("div", {
    staticClass: "shoutitle"
  }, [_c("i", {
    staticClass: "el-icon-s-marketing shouicon",
    staticStyle: {
      color: "#fc4380",
      "background-color": "#fff1f5"
    }
  }), _vm._v("\n                        待归还\n                      ")]), _vm._v(" "), _c("div", {
    staticClass: "shouvalue"
  }, [_vm._v(" " + _vm._s(_vm.data.dgh_num))])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "shouitem"
  }, [_c("div", {
    staticClass: "shoutitle"
  }, [_c("i", {
    staticClass: "el-icon-s-management shouicon"
  }), _vm._v("\n                        已支付新订单\n                      ")]), _vm._v(" "), _c("div", {
    staticClass: "shouvalue"
  }, [_vm._v(" " + _vm._s(_vm.data.pay_num))])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "shouitem"
  }, [_c("div", {
    staticClass: "shoutitle"
  }, [_c("i", {
    staticClass: "el-icon-s-marketing shouicon",
    staticStyle: {
      color: "#fc4380",
      "background-color": "#fff1f5"
    }
  }), _vm._v("\n                        待支付新订单\n                      ")]), _vm._v(" "), _c("div", {
    staticClass: "shouvalue"
  }, [_vm._v(" " + _vm._s(_vm.data.to_pay_num))])])])], 1), _vm._v(" "), _c("el-row", {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "shouitem"
  }, [_c("div", {
    staticClass: "shoutitle"
  }, [_c("i", {
    staticClass: "el-icon-s-management shouicon"
  }), _vm._v("\n                        待签约新订单\n                      ")]), _vm._v(" "), _c("div", {
    staticClass: "shouvalue"
  }, [_vm._v(_vm._s(_vm.data.to_deduct_num))])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "shouitem"
  }, [_c("div", {
    staticClass: "shoutitle"
  }, [_c("i", {
    staticClass: "el-icon-s-marketing shouicon",
    staticStyle: {
      color: "#fc4380",
      "background-color": "#fff1f5"
    }
  }), _vm._v("\n                        完成扣款订单\n                      ")]), _vm._v(" "), _c("div", {
    staticClass: "shouvalue"
  }, [_vm._v(_vm._s(_vm.data.dk_num))])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "shouitem"
  }, [_c("div", {
    staticClass: "shoutitle"
  }, [_c("i", {
    staticClass: "el-icon-s-management shouicon"
  }), _vm._v("\n                        已完成订单\n                      ")]), _vm._v(" "), _c("div", {
    staticClass: "shouvalue"
  }, [_vm._v(_vm._s(_vm.data.h_num))])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "shouitem"
  }, [_c("div", {
    staticClass: "shoutitle"
  }, [_c("i", {
    staticClass: "el-icon-s-marketing shouicon",
    staticStyle: {
      color: "#fc4380",
      "background-color": "#fff1f5"
    }
  }), _vm._v("\n                        已支付续费订单\n                      ")]), _vm._v(" "), _c("div", {
    staticClass: "shouvalue"
  }, [_vm._v(" " + _vm._s(_vm.data.xf_pay_num))])])])], 1), _vm._v(" "), _c("el-row", {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      gutter: 10
    }
  }, [_c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "shouitem"
  }, [_c("div", {
    staticClass: "shoutitle"
  }, [_c("i", {
    staticClass: "el-icon-s-management shouicon"
  }), _vm._v("\n                        代扣续费订单\n                      ")]), _vm._v(" "), _c("div", {
    staticClass: "shouvalue"
  }, [_vm._v(_vm._s(_vm.data.xf_dk_num))])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "shouitem"
  }, [_c("div", {
    staticClass: "shoutitle"
  }, [_c("i", {
    staticClass: "el-icon-s-marketing shouicon",
    staticStyle: {
      color: "#fc4380",
      "background-color": "#fff1f5"
    }
  }), _vm._v("\n                        逾期订单\n                      ")]), _vm._v(" "), _c("div", {
    staticClass: "shouvalue"
  }, [_vm._v(_vm._s(_vm.data.yq_num))])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "shouitem"
  }, [_c("div", {
    staticClass: "shoutitle"
  }, [_c("i", {
    staticClass: "el-icon-s-management shouicon"
  }), _vm._v("\n                        违约订单\n                      ")]), _vm._v(" "), _c("div", {
    staticClass: "shouvalue"
  }, [_vm._v(_vm._s(_vm.data.vy_num))])])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "shouitem"
  }, [_c("div", {
    staticClass: "shoutitle"
  }, [_c("i", {
    staticClass: "el-icon-s-marketing shouicon",
    staticStyle: {
      color: "#fc4380",
      "background-color": "#fff1f5"
    }
  }), _vm._v("\n                        续费订单\n                      ")]), _vm._v(" "), _c("div", {
    staticClass: "shouvalue"
  }, [_vm._v(_vm._s(_vm.data.xf_num))])])])], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c("el-col", {
    attrs: {
      span: 6
    }
  }, [_c("div", {
    staticClass: "carditem"
  }, [_c("div", {
    staticClass: "cardtitle"
  }, [_vm._v("\n            投诉数据\n          ")]), _vm._v(" "), _c("div", {
    staticClass: "cardcontent",
    staticStyle: {
      padding: "0 20px 10px"
    }
  }, [_c("div", {
    staticClass: "info2"
  }, [_c("div", {
    staticClass: "info2_title"
  }, [_c("div", {
    staticClass: "info2_label"
  }, [_vm._v("投诉订单")]), _vm._v(" "), _c("div", {
    staticClass: "info2_value"
  }, [_vm._v(_vm._s(_vm.data.ts_num) + "个")])]), _vm._v(" "), _c("div", {
    staticClass: "info2_icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/tousu.png"),
      alt: ""
    }
  })])]), _vm._v(" "), _c("div", {
    staticClass: "info2"
  }, [_c("div", {
    staticClass: "info2_label"
  }, [_vm._v("代扣投诉")]), _vm._v(" "), _c("div", {
    staticClass: "info2_value",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.data.dk_ts_num) + "个")])]), _vm._v(" "), _c("div", {
    staticClass: "info2"
  }, [_c("div", {
    staticClass: "info2_label"
  }, [_vm._v("代扣投诉率")]), _vm._v(" "), _c("div", {
    staticClass: "info2_value",
    staticStyle: {
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.data.dk_all_num) + "%")])])])])])], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section-header"
  }, [_c("h2", {
    staticClass: "section-title"
  }, [_vm._v("收益概览")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "section-header"
  }, [_c("h2", {
    staticClass: "section-title"
  }, [_vm._v("店铺概览")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/4.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/4.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/6.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/6.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/6.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/3.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/6.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/3.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/6.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/3.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/5.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/5.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/5.png"),
      alt: ""
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "grid-icon"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/5.png"),
      alt: ""
    }
  })]);
}];
render._withStripped = true;